module.exports = __webpack_public_path__ + "static/media/licenta27.bb8a89bb.png";